import { Injector, NgModule } from '@angular/core';
import { MessageService } from './message.service';

@NgModule({
    declarations: [],
    imports     : [],
    exports     : [],
    providers   : [ MessageService ],
})
export class MessageModule {
    constructor(private injector: Injector) {
        message = this.injector.get(MessageService);
      }
}

export let message: MessageService;
